import GinasteeLogo from './ginastee-logo.svg'

import { ReactComponent as TopRightArc } from './arc.svg'

import './styles.css'
import { ArrowDropDown, ArrowDropDownRounded, ChevronDownRounded } from '@material-ui/icons'
import { ArrowDownwardRounded, LoginRounded } from '@mui/icons-material'

export default function GlassForRoundedHero({ config }) {
    return (<div className={'glass-rounded-content-header ' + config.mode}>
        <div className='glass-rounded-header'>
            <TopRightArc className='top-right-arc header-arc' />
            <TopRightArc className='bottom-left-arc header-arc' />


            <img src={config.logo} className='glass-rounded-header-logo' />

            {
                config.options.map((mItem, i) => (
                    <a
                        className='header-anchor'
                        href={mItem.action}
                    >
                        <p>{mItem.text}</p>
                        <ArrowDropDownRounded />
                    </a>
                ))
            }

        </div>

        {
            config.login &&
            <div className='login-section'>
                <TopRightArc className='top-right-arc header-arc' />
                <TopRightArc className='top-left-arc header-arc' />


                <a
                    href={config.login}
                    className='login-header-btn'
                >
                    <p>Fazer Login</p>
                    <LoginRounded fontSize='small' />
                </a>
            </div>
        }

    </div>
    )
}